// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonZoomZoomLocked_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M17.5872 4.34315C20.7114 7.46734 20.7114 12.5327 17.5872 15.6569 16.0251 17.219 13.9777 18 11.9303 18V16C13.4658 16 15.0014 15.4142 16.173 14.2426 18.5161 11.8995 18.5161 8.1005 16.173 5.75736 13.8298 3.41421 10.0309 3.41421 7.68771 5.75736 7.60854 5.83653 7.53204 5.91737 7.45822 5.99976H5C5.34233 5.40754 5.76683 4.84981 6.2735 4.34315 9.39769 1.21895 14.463 1.21895 17.5872 4.34315ZM23.9512 20.6066 20.4156 15.6569 17.5872 18.4853 22.537 22.0208 23.9512 20.6066Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M5 8C6.65685 8 8 9.34315 8 11V13H10V20H0V13H2V11C2 9.34315 3.34315 8 5 8ZM6 11V13H4V11C4 10.4477 4.44772 10 5 10C5.55228 10 6 10.4477 6 11Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonZoomZoomLocked is a generated icon component.
 */
let IconCommonZoomZoomLocked = IconCommonZoomZoomLocked_1 = class IconCommonZoomZoomLocked extends IconBaseElement {
    render() {
        return html `${IconCommonZoomZoomLocked_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonZoomZoomLocked.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconCommonZoomZoomLocked = IconCommonZoomZoomLocked_1 = __decorate([
    customElement('zui-icon-common-zoom-zoom-locked')
], IconCommonZoomZoomLocked);
export { IconCommonZoomZoomLocked };
